export default __webpack_public_path__ + "static/media/ferrum-logo.b1adb804.svg";